import { useEffect } from 'react';
import { DataHubAPI, setDataHubAppState } from '../utils/dataHub';
import { setAppStateReference } from '../utils/auditFramework';
import { Initiative, Feature } from '../types/index';

// ============================================================================
// DATA GOVERNANCE HOOKS
// ============================================================================

export const useDataGovernance = (
  initiatives: Initiative[],
  selectedProjectId: string | null,
  selectedFeature: Feature | null
) => {
  useEffect(() => {
    // Update app state reference for DataHub and AuditFramework
    const appState = {
      initiatives,
      selectedProjectId,
      selectedFeature
    };
    
    setDataHubAppState(appState);
    setAppStateReference(appState);
    
    // Watch for data changes and ensure compliance
    const watchSubscriptions: string[] = [];
    
    // Watch all initiatives for data flow compliance
    initiatives.forEach(initiative => {
      const subscriptionId = DataHubAPI.watch(initiative.id, (change) => {
        console.log(`Data change detected for initiative ${initiative.id}:`, change);
        
        // Validate change against governance rules
        const validation = DataHubAPI.validate(change, 'initiative');
        if (!validation.valid && validation.errors.length > 0) {
          console.warn('Data governance violation detected:', validation.errors);
        }
      });
      watchSubscriptions.push(subscriptionId);
    });
    
    // Cleanup subscriptions
    return () => {
      watchSubscriptions.forEach(id => DataHubAPI.unwatch(id));
    };
  }, [initiatives, selectedProjectId, selectedFeature]);
};